const fixSignedZero = (value: number): number => {
  if (value === 0 && Object.is(-0, value)) {
    return Math.abs(value) // Fix negative zero
  } else {
    return value
  }
}

const coinAmountFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'decimal',
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 20,
    minimumFractionDigits: 0,
    maximumFractionDigits: 16,
    useGrouping: true
  })

export const roundCoinAmount = (value: number): number => {
  return fixSignedZero(Math.round((value + Number.EPSILON) * 100) / 100)
}

export const formatRoundedCoinAmount = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? coinAmountFormatter.format(roundCoinAmount(Number(value)))
    : ''
}

const usdPriceFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'decimal',
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 12,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true
  })

export const formatUsdPrice = (value: number): string | number => {
  return Number.isFinite(value) ? usdPriceFormatter.format(value) : value
}

const usdAmountFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'decimal',
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 12,
    useGrouping: true
  })

export const roundUsdAmount = (value: number): number => {
  return fixSignedZero(Math.round(value))
}

export const formatRoundedUsdAmount = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? usdAmountFormatter.format(roundUsdAmount(Number(value)))
    : ''
}

export const formatRawUsdAmount = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? usdAmountFormatter.format(Number(value))
    : ''
}

const positionFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'decimal',
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 6,
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })

export const formatRoundedPosition = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? positionFormatter.format(Number(value))
    : ''
}

export const roundInteger = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? Math.round(Number(value)).toString()
    : ''
}

const percentageFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'percent',
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 5,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })

export const formatPercentage = (value: string): string => {
  return (value !== '' && !Number.isNaN(value) && Number.isFinite(Number(value)))
    ? percentageFormatter.format(Number(value)).toString()
    : ''
}

const twoDPFormatter = new Intl.NumberFormat('en-US',
  {
    style: 'decimal',
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 8,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: false
  })

export const twoDPRounder = (value: string | number): string => {
  if (typeof value === 'string') {
    if (value === '' || value === '-') {
      return '-'
    }

    return (!Number.isNaN(value) && Number.isFinite(Number(value)))
      ? twoDPFormatter.format(Math.round((Number(value) + Number.EPSILON) * 100) / 100)
      : '-'
  } else {
    return (!Number.isNaN(value) && Number.isFinite(value))
      ? twoDPFormatter.format(Math.round((value + Number.EPSILON) * 100) / 100)
      : '-'
  }
}
